import { z } from 'zod';
/** docs section 9 "Lead Capture" — the public web-form / API endpoint.
 * No session, authenticated by API key; attribution is stored verbatim and
 * never overwritten (docs/architecture/03 § lead_attributions). */
export const publicCaptureLeadSchema = z.object({
    firstName: z.string().trim().min(1).max(100),
    lastName: z.string().trim().min(1).max(100),
    email: z.string().trim().toLowerCase().email().optional(),
    phone: z.string().trim().max(40).optional(),
    companyName: z.string().trim().max(200).optional(),
    jobTitle: z.string().trim().max(150).optional(),
    message: z.string().trim().max(2000).optional(),
    utmSource: z.string().trim().max(150).optional(),
    utmMedium: z.string().trim().max(150).optional(),
    utmCampaign: z.string().trim().max(150).optional(),
    utmTerm: z.string().trim().max(150).optional(),
    utmContent: z.string().trim().max(150).optional(),
    campaignId: z.string().trim().max(150).optional(),
    referrer: z.string().trim().max(500).optional(),
    landingPage: z.string().trim().max(500).optional(),
    /** Honeypot field — a real visitor never fills this in
     * (docs section 9 — spam protection). */
    website2: z.string().max(0).optional(),
});
export const publicCaptureLeadResponseSchema = z.object({
    leadId: z.string().uuid(),
});
//# sourceMappingURL=lead-capture.js.map